import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DashboardsIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4.94999 12.825C4.94999 13.1978 5.2522 13.5 5.62499 13.5C5.99778 13.5 6.29999 13.1978 6.29999 12.825V9.67499C6.29999 9.3022 5.99778 8.99999 5.62499 8.99999C5.2522 8.99999 4.94999 9.3022 4.94999 9.67499L4.94999 12.825Z",
                fill: "#676879"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.22499 13.5C8.8522 13.5 8.54999 13.1978 8.54999 12.825L8.54999 6.97499C8.54999 6.6022 8.8522 6.29999 9.22499 6.29999C9.59778 6.29999 9.89999 6.6022 9.89999 6.97499V12.825C9.89999 13.1978 9.59778 13.5 9.22499 13.5Z",
                fill: "#676879"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.15 12.825C12.15 13.1978 12.4522 13.5 12.825 13.5C13.1978 13.5 13.5 13.1978 13.5 12.825V5.17499C13.5 4.8022 13.1978 4.49999 12.825 4.49999C12.4522 4.49999 12.15 4.8022 12.15 5.17499V12.825Z",
                fill: "#676879"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.79999 3.59999C1.79999 2.60588 2.60588 1.79999 3.59999 1.79999H14.4C15.3941 1.79999 16.2 2.60588 16.2 3.59999V14.4C16.2 15.3941 15.3941 16.2 14.4 16.2H3.59999C2.60588 16.2 1.79999 15.3941 1.79999 14.4V3.59999ZM3.59999 3.14999H14.4C14.6485 3.14999 14.85 3.35146 14.85 3.59999V14.4C14.85 14.6485 14.6485 14.85 14.4 14.85H3.59999C3.35146 14.85 3.14999 14.6485 3.14999 14.4V3.59999C3.14999 3.35146 3.35146 3.14999 3.59999 3.14999Z",
                fill: "#676879"
            })
        ]
    });
